module.exports = __webpack_public_path__ + "static/media/gendarmerie.edd250cf.svg";